import InfoCenter from './InfoCenter'
export default InfoCenter
